import PropTypes from 'prop-types'
import classNames from 'classnames'

import CommunityAvatarPlaceholder from '../../../assets/images/mock/classRowBanner.png'
import classes from './CommunityAvatar.module.scss'

const CommunityAvatar = ({ community, size = 20, className }) => {
  const photo = community?.photo
  const src = (size <= 25 && photo?.small_file_url) || photo?.file_url || CommunityAvatarPlaceholder

  return <img className={classNames(classes.avatar, className)} style={{ width: size, height: size }} src={src} alt={community?.name} />
}

CommunityAvatar.propTypes = {
  community: PropTypes.shape({
    name: PropTypes.string,
    photo: PropTypes.shape({
      file_url: PropTypes.string,
      small_file_url: PropTypes.string,
    }),
  }),
  size: PropTypes.number,
  className: PropTypes.string,
}

export default CommunityAvatar
